export default "__VITE_ASSET__DPYFG80u__"